
document.addEventListener("DOMContentLoaded", function() {

  let lgContainer = document.querySelector(".gallery-container");
  const lg = lightGallery(lgContainer, {
    speed: 500,
    plugins: [lgZoom, lgVideo],
    selector: '.gallery-item',
    download : false,
    getCaptionFromTitleOrAlt : false,
    hideScrollbar: true,
    counter: false,
    allowMediaOverlap: true,
    videojs: true,
    mobileSettings:{ controls: false, showCloseIcon: true, download: false  } 
  });

  // Refresh after the next paint so a variant click is not blocked by the refresh
  let lgRefreshQueued = false;
  lgContainer.addEventListener('changeGalleryItems', () => {
    if (lgRefreshQueued) return;
    lgRefreshQueued = true;
    requestAnimationFrame(() => {
      setTimeout(() => {
        lgRefreshQueued = false;
        lg.refresh();
      }, 0);
    });
  });

});


